import { AuthStore } from 'src/adapters/AuthStore';

export default function createStores() {
  const authStore = new AuthStore();
  return {
    auth: authStore,
  };
}
